module.exports = __webpack_public_path__ + "img/sigreal.ef6dec91.png";